import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getWidthHeightAvatar } from '../../utils/avatar-sizes';

const getSizeProps = size => size instanceof Object ? size : getWidthHeightAvatar(size);

const Avatar = ({
  className,
  avatar,
  type = 'cropped',
  size,
  fallback = 'https://assets.myjobglasses.com/images/avatar-placeholder.png',
}) => {
  const [src, setSrc] = useState(fallback);
  useEffect(() => {
    if (avatar?.[type]?.url) {
      setSrc(avatar?.[type]?.url);
    }
  }, [avatar]);
  return (
    <img
      alt={'avatar'}
      className={className}
      src={src}
      style={{...getSizeProps(size), borderRadius: '50%'}}
    />
  );
};

Avatar.propTypes = {
  className: PropTypes.string,
  avatar: PropTypes.shape({
    url: PropTypes.string,
    cropped: PropTypes.shape({
      url: PropTypes.string,
    }),
    small: PropTypes.shape({
      url: PropTypes.string,
    }),
    thumb: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  type: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number.isRequired,
    }),
  ]),
  fallback: PropTypes.string,
};

export const AvatarWithLink = ({
  href,
  ...props
}) => (
  <Link
    to={href}
  >
    <Avatar {...props} />
  </Link>
);
AvatarWithLink.propTypes = {
  href: PropTypes.string.isRequired,
  ...Avatar.propTypes,
};

export default Avatar;
